import { ReactElement, RefObject, useState } from 'react';
import EditIcon from '../../../../components/svg/NewEditIcon';
import TextButton from '../../Buttons/TextButton';
import './ActivityCard.scss';

export enum ActivityCardStyle {
  BILL_ACTIVITY = 'bill-activity',
  BILL_HEARING = 'bill-hearing-activity',
  USER_ACTIVITY = 'user-activity',
  BILL_VOTE = 'bill-vote-activity',
  PERSON_VOTE = 'person-vote-activity',
  BILL_POSITION_STATEMENT = 'bill-position-statement',
}

type ActivityCardProps = {
  refObject?: RefObject<HTMLDivElement>;
  activityStyle?: ActivityCardStyle;
  icon?: ReactElement;
  iconColor?: string;
  pretitle?: string;
  title: ReactElement;
  subtitle?: string | ReactElement;
  isExpandable?: boolean;
  expandedContent?: ReactElement;
  isEditable?: boolean;
  edit?: () => void;
  content?: ReactElement;
  buttons?: ReactElement[];
  annotation?: ReactElement;
};

export const ActivityCard = (props: ActivityCardProps): ReactElement => {
  const {
    refObject,
    activityStyle,
    icon,
    iconColor,
    pretitle,
    title,
    subtitle,
    isExpandable,
    expandedContent,
    isEditable,
    edit,
    content,
    buttons,
    annotation,
  } = props;

  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const viewText = isExpanded ? 'View Less' : 'View More';

  return (
    <div className={`${activityStyle} activity-card`} ref={refObject || undefined}>
      <div className="ac-title d-flex flex-row">
        <div className={iconColor ? `event-icon ${iconColor}` : 'event-icon'}>
          {icon}
        </div>
        <div className="text-container">
          {pretitle && <h3 className="pretitle">{pretitle}</h3>}
          <h2
            className={
              activityStyle === ActivityCardStyle.USER_ACTIVITY ||
              activityStyle === ActivityCardStyle.BILL_POSITION_STATEMENT
                ? 'title light'
                : 'title uppercase'
            }
          >
            {title}
          </h2>
          {subtitle && <h3 className="subtitle">{subtitle}</h3>}
        </div>
        {isEditable && edit && (
          <div className="edit-button">
            <EditIcon onClick={edit} />
          </div>
        )}
      </div>
      {isExpandable && (
        <div>
          {isExpanded && <div className="expandable-content">{expandedContent}</div>}
          <div className="expandable-content-button">
            <TextButton label={viewText} onClick={() => setIsExpanded(!isExpanded)} />
          </div>
        </div>
      )}
      {content && <div className="content d-flex flex-row">{content}</div>}
      {annotation}
      {buttons && <div className="buttons d-flex justify-content-end">{buttons}</div>}
    </div>
  );
};

export default ActivityCard;
